import { Component, OnInit } from '@angular/core';
import { ToolsService } from '../../services/tools.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  expand: boolean = false;
  constructor(public tools:ToolsService) {
    this.tools.$collapseStatus.subscribe((status: any) => {
      this.expand = status;
    })
  }

  ngOnInit() {
  }
  
}
